import {
  CreateItemCacheKeys,
  FetchItemCacheKey,
  FetchItemsCacheKey,
  FetchItemsEditItem,
  FetchItemsErrorMessage,
  FetchItemsFetched,
  FetchItemsFetchingNextPage,
  FetchItemsHasNextItemsPage,
  FetchItemsIsPlaceholderData,
  FetchItemsLimit,
  FetchItemsLoadMoreItems,
  FetchItemsPage,
  FetchItemsPaginateItems,
  FetchItemsPrefetchItems,
  FetchItemsShowItem,
  FetchItemsSort,
  FetchItemsSortItems,
  FetchItemsTotalCount,
  ID,
  IDFilter,
  IdFilterType
} from '../../types';
import { ArcheidosWorkflowsEnum } from './archeidosConstants';

export type ArcheidosResultID = ID;

export type ArcheidosIdFilter = IdFilterType;

export const enum FetchArcheidosResultsFilterFields {
  ID = 'id'
}

export interface FetchArcheidosResultsFilters {
  id?: ArcheidosIdFilter;
  userId?: IDFilter;
  generationType?: ArcheidosWorkflowsEnum;
}

export type ChangeArcheidosResultsFiltersFunc = (
  changedFilters: FetchArcheidosResultsFilters,
  removeFilters?: string[]
) => void;

export const enum FetchArcheidosResultsSortableFields {
  ID = 'id'
}

export const enum FetchArcheidosResultsSortTypes {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}

export type FetchArcheidosResultsFetched = FetchItemsFetched;
export type FetchArcheidosResultsErrorArcheidos = FetchItemsErrorMessage;
export type FetchArcheidosResultsIsPlaceholderData =
  FetchItemsIsPlaceholderData;
export type FetchArcheidosResultsFetchingNextPage = FetchItemsFetchingNextPage;
export type FetchArcheidosResultsHasNextArcheidossPage =
  FetchItemsHasNextItemsPage;
export type FetchArcheidosResultsPage = FetchItemsPage;
export type FetchArcheidosResultsLimit = FetchItemsLimit;
export type FetchArcheidosResultsSort = FetchItemsSort; // FetchArcheidossSortTypes[];
export type FetchArcheidosResultsTotalCount = FetchItemsTotalCount;
export type FetchArcheidosResultsSortArcheidoss = FetchItemsSortItems;
export type FetchArcheidosResultsPaginateArcheidoss = FetchItemsPaginateItems;
export type FetchArcheidosResultsPrefetchArcheidoss = FetchItemsPrefetchItems;
export type FetchArcheidosResultsLoadMoreArcheidoss = FetchItemsLoadMoreItems;
export type FetchArcheidosResultsShowArcheidos = FetchItemsShowItem;
export type FetchArcheidosResultsEditArcheidos = FetchItemsEditItem;

export type FetchArcheidosResultCacheKey = FetchItemCacheKey;
export type FetchArcheidosResultsCacheKey = FetchItemsCacheKey;
export type CreateArcheidosStyleTransferCacheKeys = CreateItemCacheKeys;
export type CreateArcheidosImageGeneratorCacheKeys = CreateItemCacheKeys;

export type ArcheidosFieldType = {
  choices?: Record<string, string>;
  default?: number | string;
  hint_type?: string;
  input_type: string;
  max_size?: number;
  max_value?: number;
  min_value?: number;
  name?: string;
  placeholder?: string;
  required?: boolean;
  rows_number?: number;
  step_value?: number;
  visible_if?: string;
};
